import loadable from '@loadable/component';
import React from 'react';

import { UserReviewSummary, UserReview, PageInfo } from '../../../../types';

type BelongsTo = {
  id: number;
  name: string;
  type: 'product' | 'store';
};

type Props = {
  belongsTo: BelongsTo;
  myReview?: UserReview | null;
  summary: UserReviewSummary;
  nodes?: (UserReview | null)[] | null;
  pageInfo?: PageInfo | null;
};

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "extra" */ '../../../reviews')
);

const UserReviewsLoader = (props: Props) => {
  // Data not loaded
  if (!props.pageInfo) {
    return null;
  }

  return <LoadableComponent {...props} />;
};

export default UserReviewsLoader;
